module.exports = __webpack_public_path__ + "static/media/galerija_2023 (18).ffd18fcd.png";